import { render, staticRenderFns } from "./PostbackDataCell.vue?vue&type=template&id=5911d5d2&scoped=true&"
import script from "./PostbackDataCell.vue?vue&type=script&lang=babel&"
export * from "./PostbackDataCell.vue?vue&type=script&lang=babel&"
import style0 from "./PostbackDataCell.vue?vue&type=style&index=0&id=5911d5d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911d5d2",
  null
  
)

export default component.exports